import { useContext, useEffect, useState } from 'react';
import { Select, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import { strapiRequest } from '../../functions/axiosRequest';
import { LanguageContext } from '../../context/LanguageContext';

export default function CropSelect({ selectedCrop, setSelectedCrop, textData }){

	const locale=useContext(LanguageContext);

	const [crops, setCrops] = useState();

	const { data } = useQuery(['crops', locale],
		() => strapiRequest({
			method: 'get',
			endpoint: 'categories',
			params:{
				'locale':locale.lang.code
			}
		}), {
		retry: 1
	});

	useEffect(() => {
		if (data) {
			setCrops(data.data)
			setSelectedCrop(data.data[0])
		}
	}, [data]);

	return(
		<>
			<Typography
				sx={{
					fontSize:'0.8rem',
					color:'grey'
				}}
			>
				{textData?.repository_crop_select}
			</Typography>
			<Select
				native
				fullWidth
				value={selectedCrop?.documentId}
				onChange={(event)=>{
					const match=crops.find(crop=>crop.documentId===event.target.value);
					if(match){
						//console.log(match)
						setSelectedCrop(match);
					}
				}}
			>
				{crops?.map((crop, i)=>{
					return(
						<option
							value={crop.documentId}
							key={i}
						>
							{crop.title}
						</option>
					);
				})}
			</Select>
		</>
	);
};
